import React, { Component } from 'react';
import Config from './Config';
import List from './List';
import { Scrollbars } from 'react-custom-scrollbars';
import './css/Order.css';
import Modal from './Modal';
import FX from './functions/functions';
import SearchBox from './SearchBox';
import OrderEdge from './OrderEdge';
import AddressEditor from './AddressEditor';
import AddressViewer from './AddressViewer';
import ContextMenu from './ContextMenu';
import Calendar from './Calendar';
import ConsignmentViewer from './ConsignmentViewer';

class Order extends Component {
  constructor(props) {
    super(props);
    this.state = { activeProduct: null, showSide: true, context: {show:false}, orders: false, checked: [], drawerState: undefined, page: 0 };
    this.props.root.autoKey = this.autoKey;
  }
  autoKey = (e) => {
    if(e.key === 'Enter'){
        console.log(e.target.id.split("_")[0]);
        console.log(this.enterAction);
        if(typeof this.enterAction[e.target.id.split("_")[0]] === 'function'){
           this.enterAction[e.target.id.split("_")[0]](e);
        }
    }
    console.log('xxx');
    console.log(e);
    console.log(e.key);
  }
  componentDidMount(){
    console.log('oooo');
    this.retrieveData(30);
  }
  showCalendar = (tgt, e) => {
    var detail = this.props.root.state.detail;
    console.log(e);
    console.log(e.type);
    console.log([e.clientX,e.clientY]);
    var loc;
    if(e.type === 'focus'){
      loc = e.target.getBoundingClientRect();
      console.log(loc);
      loc = [loc.left,loc.bottom];
    }
    else {
      loc =  [e.clientX,e.clientY];
    }
    console.log(loc);
    if(tgt === 'release_date' || tgt === 'expiry'){
        this.setState({showCalendar: {location: loc, target: tgt}});
    }
  }
  toggleDrawer = () => {
    var drawerState = (this.state.drawerState === 'open') ? undefined : 'open';
    this.setState({drawerState : drawerState});
    console.log(drawerState);
  }
  enterAction = {
    'recBox': (e)=> {
      console.log(e.key);
      e.target.blur();
      this.closeProductModal();
    },
    'activeProductQty' : (e) => {
      console.log(e.key);
      e.target.blur();
      this.addActiveItem();
    },
    'lookupBox' : (e) => {
      console.log(e.key);
      e.target.blur();
      this.dbSearch();
    }
  }
  componentDidUpdate(prevprops, prevstate){
    FX.doFocus(this);
    console.log(prevstate);
    console.log(prevprops);
    console.log(this.props.root.state.detail);
    console.log(prevprops.root.state.detail);
    console.log(this.loading);
    var k = parseInt( this.props.root.state.detail , 10 );
    if( !this.loading && typeof this.props.root.state.detail === 'number'  ){
       this.loading = true;
       console.log(this.props.root.state.detail);
       this.retrieveDetail(this.props.root.state.detail);
    }
    FX.doFocus(this);
    //console.log(Syst);
  }
  componentWillMount(){
     FX.urlRetrieve.bind(this)(this.props.root.state);
  }
  setPage = page => {
    console.log(page);
    if(page.action === '+1'){
      page.action = this.state.page + 1;
    }
    else if(page.action === '-1'){
      page.action = this.state.page -1;
    }
    console.log(page);
    this.retrieveData(30, page.action);
  }
  retrieveData = (limit, page) => {
    if(isNaN(limit)){
      limit = 30;
      if(parseInt(this.props.root.state.current_customer.orders.limit,10)){
        //console.log(limit = parseInt(limit,10) + parseInt(this.props.root.state.current_customer.orders.limit,10));
      }
    }
    if(isNaN(page)){
      page = 0;
    }
    var sort_str = this.props.root.sort_str ? this.props.root.sort_str : '';
    var data = {customer_id: this.props.root.state.customer_id, sort: sort_str, limit: limit, page: page, sort:JSON.stringify(this.state.sort), filter:JSON.stringify(this.state.filter)};
    var qs = FX.encodeQueryData(data, true);
    FX.load(this.props.root,'order' + qs , (res, i) => {
      var currCust = this.props.root.state.current_customer;
      console.log(res);
      currCust.orders.list = res.orders;
      currCust.orders.count = res.count;
      currCust.orders.limit = res.limit;
      currCust.orders.pages = res.pages;
      currCust.orders.page = res.page;
      this.setState({page: res.page});
      currCust.orders.data = data;
      currCust.orders.path = 'order';
      this.props.root.setState({ current_customer : currCust  });
      this.props.root.loadNextPage =  this.retrieveData;
    });
  }
  retrieveDetail = (id) => {
    console.log('pop');
    var sort_str = this.props.root.sort_str ? this.props.root.sort_str : '';
    FX.load(this.props.root,'order/' + id , (res, i) => {
      console.log(res.order);
      console.log('xxxxp');
      if(res.order && res.order.id){
        var detail = res.order;
        if(res.consignment && Array.isArray(res.consignment) && res.consignment.length){
          try{
            detail.consignment = res.consignment[0].consignment;
          }
          catch(e){
            console.log(e);
          }
        }
        this.props.root.setState({ detail : res.order  });
      }
      else {
        FX.navigate.bind(this.props.root, this.props.root.state.panel, undefined ,'/orders')();
      }
      this.loading = false;
    });
  }
  save = () => {
    console.log(this.props.root.state.detail);
    var detail = this.props.root.state.detail;
    var createDispatch;
    if(!detail.order_items.length){
      alert('Please add products before saving order');
        this.focusTgt = 'prod_search';
        this.forceUpdate();
        return false;
    }
    if(parseInt(detail.post_service_id) <= 0){
      alert("Please select a shipping service.");
      this.focusTgt = 'service_select';
      this.forceUpdate();
      return false;
    }
    if(!FX.validateAddress(detail.delivery_address) && parseInt(detail.post_service_id) !== 17){
      FX.validateAddress();
      window.confirm("Please enter a delivery address.");
      return false;
    }
    if(!detail.reference.trim()){
      if(!window.confirm("You haven't entered a reference - should we create one?")){
        this.focusTgt = 'reference';
        this.forceUpdate();
        return false;
      }
    }
    if(detail.id ===  -1){
      createDispatch = window.confirm("Create a dispatch containing all of items?");
    }
    FX.load(this.props.root,'order/save' , (res, i) => {
          console.log(res);
          console.log(res.success);
          if(res.success){
             console.log(res);
          }
          if(createDispatch){
            //this.addAsNewDispatch('ALL');
          }
          this.props.root.setState({detail : res.order});
          this.retrieveData();
          this.props.root.changed = false;
    }, {method:'POST',data:{detail : detail, createDispatch:createDispatch}});
  }
  deleteDispatch = ( disp, e ) => {
    e.preventDefault();
    e.stopPropagation();
    if(window.confirm('Are you wish to delete this dispatch?\nThis action can not be undone.')){
        console.log(disp);
        FX.load(this.props.root,'dispatch/delete' , (res, i) => {
              console.log(res);
              console.log(res.success);
              if(res.success){
                 console.log(res);
              }
              //this.props.root.setState({detail : res.order});
        }, {method:'POST',data:{dispatch : disp}});
        this.retrieveDetail(this.props.root.state.detail.id);
    }
  }
  showList = () => {
    //this.props.root.setState({detail:undefined});
    FX.navigate.bind(this.props.root, this.props.root.state.panel, undefined ,'/orders')();
  }
  selectProduct = (prod) => {
    console.log(prod);
    console.log(this.props.root.state.detail.order_items);
    this.setState({activeProduct : prod});
    this.focusTgt = 'activeProductQty';
    console.log('xxxx');
  }
  addActiveItem = () => {
    var found = false;
    var detail = this.props.root.state.detail
    var order_items = detail.order_items;
    var activeProduct = this.state.activeProduct;
    order_items.some( (oi, i) => {
        console.log(this.state.activeProduct.id);
        console.log(oi);
        if(this.state.activeProduct.id == oi.product.id){
          oi.quantity += parseInt(document.getElementById('activeProductQty').value, 10);
          found = true;
        }
        return found;
    });
    if (!found) {
      console.log(this.state.activeProduct.name);
      order_items.push({
        id:-1,
        product: activeProduct,
        product_id: activeProduct.id,
        quantity: parseInt(document.getElementById('activeProductQty').value, 10)
      });
    }
    detail.order_items = order_items;
    this.setState({activeProduct: null});
    this.props.root.setState({order_items : order_items});
    this.focusTgt = 'prod_search';
  }
  removeItem = (prod) => {
    console.log(prod);
    if(!window.confirm('Are you sure you wish to remove this item.')){
      return false;
    }
    var order_items = this.props.root.state.detail.order_items;
    order_items.some( (oi, i) => {
        if(prod == oi.product_id){
          order_items.splice(i,1);
          return true;
        }
        return false;
    });
    this.props.root.setState({order_items : order_items});
  }
  contextHide = () => {
    this.setState({context: false});
  }
  contextShow = (target, e) => {
    if(target.product){
      var options = [{title: "View Product",action:()=>{FX.navigate.bind(this.props.root, 'products'  , undefined ,'/products/'+target.product.id)() }}]
      this.setState({context : {show: true, location: [e.clientX,e.clientY], options: options}});
    }
    else {
      var options = [{title: "Cancel Order",action:this.cancelOrder},{title: "Match Dispatch",action:this.matchDispatch}]
      this.setState({context : {show: true, location: [e.clientX,e.clientY], options: options}});
    }
  }
  matchDispatch = ( ) => {
    if(!this.state.showWarn){
    this.setState({showWarn: {
      message:(<p>This will set the dispatch to match the current composition and delivery address of the order. Are you sure?</p>),
      buttons:[{className:'cancel', text:'Cancel', action: (e)=>{this.setState({showWarn:undefined});}}, {className:'ok', text:'OK', action: (e)=>{if(typeof this.state.showWarn.callback === 'function'){this.state.showWarn.callback()};this.setState({showWarn:undefined});} }],
      callback: this.matchDispatch}
    });
    }
    else {
      FX.load(this.props.root,'dispatch/matchOrder' , (res, i) => {
        console.log(res);
        if(res.success){
            console.log('alertXX');
            FX.navigate.bind(this.props.root, this.props.root.state.panel, res.show ,'/orders/'+res.show)();
            this.closeModal();
        }
        else {
            var msg = 'These orders cannot be merged:';
            res.stop.forEach( stop => {
                msg += '\n ' + stop.reference + ' ' + stop.statusName;
            });
            window.confirm(msg);
        }
      }, {method:'POST',data:{order_id : this.props.root.state.detail.id }});
    }
  }
  cancelOrder = ( ) => {
    if(!this.state.showWarn){
    this.setState({showWarn: {
      message:(<p>Cancel this order and all of its dispatches?</p>),
      buttons:[{className:'cancel', text:'Cancel', action: (e)=>{this.setState({showWarn:undefined});}}, {className:'ok', text:'OK', action: (e)=>{if(typeof this.state.showWarn.callback === 'function'){this.state.showWarn.callback()};this.setState({showWarn:undefined});} }],
      callback: this.cancelOrder}
    });
    }
    else {
      FX.load(this.props.root,'order/cancel' , (res, i) => {
        console.log(res);
        if(res.success){
           this.retrieveData();
           this.props.root.setState({detail:undefined});
        }
        else {
        }
      }, {method:'POST',data:{order_id : this.props.root.state.detail.id }});
    }
  }
  editAddress = (tgt) => {
    this.setState({editAddress: tgt});
  }
  closeModal = () => {
    this.orderUncheck();
    this.setState({editAddress:undefined,mergeConfirm:false,uploader: false});
  }
  orderUncheck = (obj) => {
    var d = document.querySelectorAll('#orders .lineSelect:checked');
    d.forEach(_d => {
        _d.checked = false;
    });
  }
  orderCheck = (obj) => {
    if(!Array.isArray(this.props.root.state.current_customer.orders.list)){
      return false;
    }
    var d = document.querySelectorAll('#orders .lineSelect:checked');
    var out = [];
    d.forEach(_d => {
        console.log(_d);
        console.log(this.props.root.state.current_customer.orders.list);
        if(Array.isArray( this.state.orders )){
            this.state.orders.some(ord => {
                if(ord.id == _d.dataset.obj_id){
                   out.unshift(ord);
                  return true;
                }
                return false;
            })
        }
    });
    this.setState({checked: out});
    console.log(out)
    return out;
  }
  mergeOrders = () => {
    var merge = this.orderCheck();
    this.setState({mergeConfirm: true});
  }
  merge = () => {
    FX.load(this.props.root,'order/merge' , (res, i) => {
      console.log(res);
      if(res.success){
          console.log('mlkmlk');
          FX.navigate.bind(this.props.root, this.props.root.state.panel, res.show ,'/orders/'+res.show)();
          this.closeModal();
      }
      else {
          var msg = 'These orders cannot be merged:';
          res.stop.forEach( stop => {
              msg += '\n ' + stop.reference + ' ' + stop.statusName;
          });
          window.confirm(msg);
      }
    }, {method:'POST',data:{merge : this.state.checked, mergeTo: document.getElementById('mergeTo').value}});
  }
  setAddress = (data, target) => {
    console.log(target, data);
    if(target){
      this.props.root.changed = true;
      var detail = this.props.root.state.detail;
      var targets = ['delivery_address', 'invoice_address'];
      if(detail[target]){
        var add_id = detail[target].id;



                if(target === 'delivery_address'){
                    detail['shopper_address_id_delivery'] = add_id
                }
                else if(target === 'invoice_address'){
                    detail['shopper_address_id_invoice'] = add_id
                }







        targets.forEach((tgt, i) => {
            if( 0 && add_id !== -1 && add_id == detail[tgt].id && tgt !== target){
                detail[tgt] = data;
                if(target === 'delivery_address'){
                    detail['shopper_address_id_delivery'] = add_id
                }
                if(target === 'invoice_address'){
                    detail['shopper_address_id_invoice'] = add_id
                }
            }
        })
      }
      detail[target] = data;
      this.props.root.setState({detail:detail});
    }
    this.closeModal();
  }
  nextReference = () => {
    var detail = this.props.root.state.detail;
    console.log(detail.dispatch);
    return '!next';
  }
  addAsNewDispatch = () => {
    var detail = this.props.root.state.detail;
    var dispatch = {
        id:-1,
        order_id: detail.id,
        customer_id:detail.customer_id,
        user_login_id: this.props.root.state.user.id,
        reference: this.nextReference(),
        dispatch_items:[],
        notes:detail.notes,
        post_service_id:detail.post_service_id,
        gift_message:detail.gift_message,
        delivery_instructions:detail.delivery_instructions,
        delivery_address: detail.delivery_address
    };
    var d = document.querySelectorAll('input.outstanding:checked');
    for(var i=0;i<d.length;i++){
      this.props.root.state.detail.warn.some(w => {
        if(w.id == d[i].dataset.warn_id){
          //list.push(d[i].dataset.warn_id);
          dispatch.dispatch_items.push({id:-1, product_id:  w.outstanding.product_id, quantity:  w.outstanding.outstanding});

          return true;
        }
        return false;
      })
    }
    console.log(dispatch);
    FX.load(this.props.root,'orderDispatch/create/' + detail.id , (res, i) => {
      console.log(res);
          this.props.root.setState({detail : res.order});
    }, {method:'POST',data:{dispatch : dispatch}});
  }
  dbSearch = () => {
    var data = {lookup : document.getElementById('lookupBox').value};
    if(!this.props.all_customers || (!this.isAdmin() && this.props.root.state.customer_id)){
        data.customer_id = this.props.root.state.customer_id;
    }
    FX.load(this.props.root,'order/lookup/' , (res, i) => {
      console.log(res);
          this.setState({orders : res.orders});
    }, {method:'POST',data:data});
  }
  add_new_btn = () => {

    if(document.querySelectorAll('input.outstanding:checked').length){
      document.getElementById('add_new_btn').style.display = 'inline-block'
    }
    else {
      document.getElementById('add_new_btn').style.display = 'none'
    }
  }



  markCollected = (disp,e) => {
    if(e){
    e.preventDefault();
    e.stopPropagation();
    }
    console.log(disp);


      if(!this.state.showWarn){
      this.setState({showWarn: {
        message:(<p>Are you sure that you wish to mark this dispatch as collected?<br/><br/>This action can not be undone.</p>),
        buttons:[{className:'cancel', text:'Cancel', action: (e)=>{this.setState({showWarn:undefined});}}, {className:'ok', text:'OK', action: (e)=>{if(typeof this.state.showWarn.callback === 'function'){this.state.showWarn.callback()};this.setState({showWarn:undefined});} }],
        callback: this.markCollected.bind(this, disp , ),
        textField: {label:"Tracking Code", value:'', handle:(e)=>{var sw = this.state.showWarn; sw.textField.value = e.target.value; this.setState({showWarn:sw});}}
      }});
      }
    else {
      FX.load(this.props.root,'dispatch/complete' , (res, i) => {
        console.log(res);
        if(res.success){
            console.log('alertXX');
            FX.navigate.bind(this.props.root, this.props.root.state.panel, res.show ,'/orders/'+res.show)();
            this.closeModal();
        }
        else {
            var msg = 'These orders cannot be merged:';
            res.stop.forEach( stop => {
                msg += '\n ' + stop.reference + ' ' + stop.statusName;
            });
            window.confirm(msg);
        }
      }, {method:'POST',data:{dispatch : disp, tracking_code: this.state.showWarn.textField.value }});
    }
  }












  createNew = () => {
    this.props.root.setState({detail:{
        id:-1,
        customer_id:this.props.root.state.customer_id,
        user_login_id: this.props.root.state.user.id,
        reference: '',
        order_items:[],
        dispatches:[],
        notes:'',
        order_status: 0,
        post_service_id:-1,
        gift_message:'',
        delivery_instructions:'',
        invoice_address: null,
        delivery_address: null
    } })
  }
  handler = (tgt, e) => {
    if(tgt === 'this.dbSearchText'){
        this.setState({dbSearchText:e.target.value});
        return false;
    }
    this.props.root.changed = true;
    var detail = this.props.root.state.detail;
    detail[tgt] = e.target.value;
    this.props.root.setState({detail:detail});
  }
  showLookup = () => {
      this.setState({showLookup:!this.state.showLookup});
  }
  upOrder = (e) => {
      console.log(e);

      var file    = e.target.files[0];
      var reader  = new FileReader();

      reader.addEventListener("load", () =>  {
        //preview.src = reader.result;
        console.log(reader.result);
        var k;
        var fields;
        console.log(k = reader.result.split('\n'));
        console.log(fields = k[0].replace(/\"/g,'').split(','));
        console.log(k);

        var required = ["ID", "OrderId", "SKU", "Quantity", "Channel", "BuyerName", "BuyerAdd1", "BuyerAdd2", "BuyerAdd3", "BuyerCity", "BuyerCounty", "BuyerPostcode", "BuyerCountry", "RecipientName", "RecipientAdd1", "RecipientAdd2", "RecipientAdd3", "RecipientCity", "RecipientCounty", "RecipientPostcode", "RecipientCountry", "OrderVariations", "OrderNotes", "Status", "PurchaseDate", "ShippingMethod"];
        var _valid  = 1;
        for(var i = 0; i < required.length; i++){
            console.log(required[i], fields.includes(required[i]));
            if (!fields.includes(required[i])){
              _valid = false;
              console.log(required[i]);
            }
            console.log(_valid);
        }
        console.log(_valid);


        if(_valid){

            FX.load(this.props.root,'order/upload/bulk' , (res, i) => {
              console.log(res);

              setTimeout(() => {
                  this.retrieveData(30);
              }, 1000);
                  //this.props.root.setState({order : reader.result, customer_id: this.props.root.state.customer_id});
            }, {method:'POST',data:{data : reader.result, customer_id: this.props.root.state.customer_id}});
        }
        else {
          alert("The header format doesn't match our specification,\nplease ensure that both header and data match the template.")
        }


      }, false);
      if (file) {
        reader.readAsText(file);
      }
  }
  isAdmin = () => {
    var user = this.props.root.state.user;
    return parseInt(user.admin_level, 10);
  }
  sortAction = ( sort , filter) => {
    console.log(sort);
    console.log(filter);
    var filters = [];
    if(filter.length){
      filter.forEach((filt) => {
        if (filt.active && filt.active.length){
          filters.push({field: filt.field, active: filt.active});
        }
      });
      console.log(filters);
    }
    this.setState({sort: sort, filter: filters}, this.retrieveData);
  }
  isEditable = () => {
    var editable = 0;
    var detail = this.props.root.state.detail;
    if (detail.order_status < 10){
        editable = 1;
    }
    if (detail.order_status < 50 && this.isAdmin()){
        editable = 1;
    }
    return editable;
  }
  toggleSide = () => {
    this.setState({showSide:!this.state.showSide});
  }
  render() {
    if(this.props.root.state.detail && typeof this.props.root.state.detail !== 'number' && typeof this.props.root.state.detail.dispatches ){
      var detail = this.props.root.state.detail;
        console.log(this.props.root.state.detail);
      var dispatches = this.props.root.state.detail.dispatches.map(disp =>{
        console.log(disp);
        var border;
        if(disp.dispatch_status >= 0 && disp.dispatch_status < 10 ){
          border = 'solid 3px #d00';
        }
        else if(disp.dispatch_status < 40) {
          border = 'solid 3px #ff0';
        }
        else {
          border = 'solid 3px #0b0';
        }
        var removeBtn;
        var sendBtn;
        if(this.isEditable()){
             removeBtn = <i onClick={this.deleteDispatch.bind(this, disp)} className="material-icons delete-button">close</i>
        }
        if(this.isEditable() && this.isAdmin() && disp.dispatch_status >= 30 && disp.dispatch_status < 50){
             sendBtn = <i title="Mark this dispatch as collected" onClick={this.markCollected.bind(this, disp)} className="material-icons delete-button">assignment_turned_in</i>
        }
        return (<div className="dispatchLink" style={{borderLeft: border}}  onMouseUp={(e)=>{console.log(e); if(e.button == 1){ window.open('/dispatches/'+disp.id);}}} onClick={FX.navigate.bind(this.props.root, 'dispatches'  , disp.id ,'/dispatches/'+disp.id)} >
                    <span className="dispatchName"><i className="fa fa-cube icon" aria-hidden="true" />{disp.reference}</span>
                     - <span className="status">{FX.status('dispatches',disp.dispatch_status)}</span>
                     {sendBtn}{removeBtn}
                </div>);
      })

      if(dispatches.length){
       dispatches = ( <div className="dispatches">
                        <div className="label">Dispatches</div>
                        {dispatches}
                      </div> )

      }


            var order_headers = (
              <tr className="header">
                <th></th>
                <th>Product</th>
                <th>Qty</th>
                <th></th>
              </tr>
            );
      var order_items = this.props.root.state.detail.order_items.map(oi =>{
        console.log(oi);
            var lineClass = '';
            var stock = '';
            var barcode;

            if(oi.product.barcode){
              barcode = (<span className="product_barcode">{oi.product.barcode}</span>)
            }

        var removeBtn;
        if(this.isEditable()){
             removeBtn = <i onClick={this.removeItem.bind(this, oi.product_id)} className="material-icons product_remove">close</i>
        }


        return (


              <tr className={lineClass}>
                <td><input type="checkbox" className="product_check" data-dispatch_item_id={oi.id}/></td>
                <td>
                  <span className="product_name">{oi.product.name}</span>
                  <span className="product_sku">{oi.product.sku}</span>
                  {barcode}
                </td>
                <td className="product_quantity">{oi.quantity}</td>
                <td>
                  <span className="product_menu" onClick={this.contextShow.bind(this,oi)}><i className="fa fa-sis-v" /></span>
                  {removeBtn}
                </td>
              </tr>



        );
        return <div><input type="checkbox" className="product_check" data-dispatch_item_id={oi.id}/> {oi.product.sku} {oi.product.name} {oi.quantity}<div></div></div>;
      })
      var active;
      var fixedTop;
      if (this.state.activeProduct){
        active = (
          <div className="activeProduct">{this.state.activeProduct.sku} - {this.state.activeProduct.name} <input id="activeProductQty" onFocus={(e) => {this.props.root.autoKey = this.autoKey;}}/><button onClick={this.addActiveItem} ><i className="material-icons">add</i></button></div>
        );
      }
      if(this.isEditable()){
         fixedTop =  ( <div className="fixedTop">
                        <SearchBox showAllocated={true} parent={this} root={this.props.root}></SearchBox>
                        {active}
                      </div>)
      }
      var editAddress;
      if(this.state.editAddress){
        editAddress = (
            <AddressEditor root={this.props.root} title={this.state.editAddress} varTgt={this.state.editAddress + "_address"} hideAddress={this.setAddress} />
        )
      }
      var warning;
      var warn;
      if(this.props.root.state.detail.warn){
        warn = this.props.root.state.detail.warn.map(w => {
          warning = true;
          var className;
          var checkBox;
          if(w.outstanding.outstanding > 0){
            className = 'under'
            checkBox = <input type="checkbox" onClick={this.add_new_btn} className="outstanding" data-warn_id={w.id} />
          }
          else if (w.outstanding.outstanding < 0){
            className = 'over'

          }
          return <div className={className} >{checkBox} {w.outstanding.sku} - {w.outstanding.name}: Outstanding: {w.outstanding.outstanding} </div>
        });
        if(warning){
            warn = (<div>
                      {warn}
                      <div>
                        <button id="add_new_btn" style={{display: 'none'}} onClick={this.addAsNewDispatch}>Add as New Dispatch</button>
                      </div>
                    </div>);
        }
      }
      var sideButtons;
      if (!this.isEditable()) {
        sideButtons = (
            <div id="sideButtons">
              <button  onClick={this.showList}>Back</button>
              </div>
        )
      }
      else {
        sideButtons = (
            <div id="sideButtons">
              <button  onClick={this.showList}>Back</button>
              <button onClick={this.save}>Save</button>
            </div>
        )
      }
      var reference;
      if(this.props.root.state.detail.id != -1) {
        reference = (<div className="reference">{this.props.root.state.detail.reference}<span>{this.props.root.state.detail.id}</span></div>);
      }
      else {
        reference = (<div className="reference"><input id="reference" value={this.props.root.state.detail.reference} placeholder="Please Enter Reference" onChange={this.handler.bind(this, 'reference')} /></div>);
      }



      var calendar;
        console.log(this);
      if (this.state.showCalendar && this.state.showCalendar.target === 'release_date'){
        console.log('test');
        calendar = (
            <ContextMenu show={true}  contextHide={() =>{ this.setState({showCalendar: undefined}); console.log(this);}} location={this.state.showCalendar.location} parent={this}>
                <Calendar date={detail.release_date} close={(date) => {detail.release_date = FX.dateFormat(date,'php'); this.props.root.setState({detail:detail}); this.setState({showCalendar:false})}} range={false} />
            </ContextMenu>
        )
      }
      var release_date;
      if(detail.release_date && FX.dateFormat(detail.release_date,'{U}') > FX.dateFormat(new Date,'{U}')){
         release_date = (
                <div className="dispatch_date release"  onClick={this.showCalendar.bind(this,'release_date')}>
                  <div className="title">Release Date:</div>
                  {FX.dateFormat(detail.release_date,'{d2}/{m2}/{Y}')}
                  </div>
                  );
      }
      else if(this.isEditable()) {
         release_date = (
                <div className="dispatch_date predicted">
                  <div className="title">Expected Dispatch:</div>
                  {FX.dateFormat(this.props.root.state.detail.order_date,'{d2}/{m2}/{Y}')}
                  <div className="delay_btn" title="Delay Dispatch"  onClick={this.showCalendar.bind(this,'release_date')}>
                    <i className="fa fa-calendar" aria-hidden="true"></i>
                  </div>
                </div>)
      }





      var order_date;
      if(detail.id != -1 && detail.order_status < 50) {
        order_date = (
            <div className="dates">
                <div className="order_date">
                  <div className="title">Order date:</div>{FX.dateFormat(this.props.root.state.detail.order_date)}
                </div>
                {release_date}
            </div>);
      }
      else if(detail.id != -1 ) {
        order_date = (
            <div className="dates">
                <div className="order_date">
                  <div className="title">Order date:</div>{FX.dateFormat(this.props.root.state.detail.order_date)}
                </div>
                <div className="dispatch_date">
                  <div className="title">Dispatched:</div>{FX.dateFormat(this.props.root.state.detail.dispatch_completed_date)}
                </div>
            </div>);
      }
      else if(detail.id != -1 ) {
        order_date = (
            <div className="dates">
                <div className="order_date">
                  <div className="title">Order date:</div>{FX.dateFormat(this.props.root.state.detail.order_date)}
                </div>
                <div className="dispatch_date predicted">
                  <div className="title">Dispatch date (predicted):</div>{FX.dateFormat(this.props.root.state.detail.dispatch_completed_date)}
                </div>
            </div>);
      }

      if(this.isEditable()){
        var ps_set = [];
        var post_services = [{id:-1, name: '--------', client_selectable: 1}].concat( this.props.root.state.utilities.post_services).map(ps => {
          if(ps.client_selectable == 1 && !ps_set.includes(parseInt(ps.id,10))){
              ps_set.push(parseInt(ps.id,10));
              return (<option value={parseInt(ps.id,10)} >{ps.name}</option>)
          }
        });

         post_services  = (<select className="service_select" id="service_select" value={parseInt(this.props.root.state.detail.post_service_id,10)} onChange={this.handler.bind(this, 'post_service_id')}>
                    {post_services}
                  </select>)
      }
      else {
        this.props.root.state.utilities.post_services.some(ps => {
          if(parseInt(ps.id,10) === parseInt(this.props.root.state.detail.post_service_id,10)){
            post_services = <div className="postService">{ps.name}</div>
            return true;
          }
          return false;

        })
      }


      var drawer_info;
      if((this.props.root.state.detail.delivery_instructions && this.props.root.state.detail.delivery_instructions.trim()) || (this.props.root.state.detail.notes && this.props.root.state.detail.notes.trim()) || (this.props.root.state.detail.gift_message && this.props.root.state.detail.gift_message.trim()) ){
          drawer_info = <div className="info_mark">!</div>;
      }
      console.log(this.state.drawerState);
      var className = "Order"
      if(this.isEditable()){
        className += ' editable';
      }
        var order_status;
        var status_class = "status";
        var export_options;
        if (this.props.root.state.detail.delivery_address && (this.props.root.state.detail.delivery_address.country_code != "GB" || "BT" === FX.postcodeFormat(this.props.root.state.detail.delivery_address.postcode, this.props.root.state.detail.delivery_address.country_code).substr(0,2))){
            export_options = (<div className="export_options">
                <h4>Export Options</h4>
                <div>
                <label class="label">Export Terms</label>
                <select disabled>
                    <option>DAP: Delivered At Place</option>
                </select>
                </div>
                <div>
                <label class="label">Export Reason</label>
                <select disabled>
                    <option>Sale of Goods</option>
                </select>
                </div>
            </div>);
        } 
        if(detail.order_status >= 30){
            status_class += ' packed';

        }
        else if(detail.order_status >= 10){
            status_class += ' active';
        }
        else {
            status_class += ' issue';
        }
        order_status = <div className={status_class}>{FX.status('orders',this.props.root.state.detail.order_status)}</div>
          var address_blocks;
          if(this.isEditable() && (!this.props.root.state.detail.invoice_address || !this.props.root.state.detail.invoice_address.id || JSON.stringify(this.props.root.state.detail.delivery_address) == JSON.stringify(this.props.root.state.detail.invoice_address))){
             address_blocks = (
                 <div className="address_block">
                    <AddressViewer onClick={()=>{this.editAddress('delivery')}} title="Delivery Address" address={this.props.root.state.detail.delivery_address} root={this.props.root} varTgt="delivery_address"/>
                    <AddressViewer onClick={()=>{this.editAddress('invoice')}} title="Invoice Address" address={this.props.root.state.detail.invoice_address} matched={'Delivery Address'} root={this.props.root} varTgt="invoice_address"/>
                    <div className='tidy' />
                  </div>
                )
           }
           else if(this.isEditable()){
             address_blocks = (
                 <div className="address_block">
                    <AddressViewer onClick={()=>{this.editAddress('delivery')}} title="Delivery Address" address={this.props.root.state.detail.delivery_address} root={this.props.root} varTgt="delivery_address"/>
                    <AddressViewer onClick={()=>{this.editAddress('invoice')}} title="Invoice Address" address={this.props.root.state.detail.invoice_address} root={this.props.root} varTgt="invoice_address"/>
                    <div className='tidy' />
                </div>
             )
           }
          else if(!this.props.root.state.detail.invoice_address.id || JSON.stringify(this.props.root.state.detail.delivery_address) == JSON.stringify(this.props.root.state.detail.invoice_address)){
             address_blocks = (
                 <div className="address_block">
                    <AddressViewer title="Delivery Address" address={this.props.root.state.detail.delivery_address} root={this.props.root} varTgt="delivery_address"/>
                    <AddressViewer title="Invoice Address" address={this.props.root.state.detail.invoice_address} matched={'Delivery Address'} root={this.props.root} varTgt="invoice_address" />
                  <div className='tidy' />
              </div>
                )
           }
           else {
             address_blocks = (<div className="address_block"><AddressViewer title="Delivery Address" address={this.props.root.state.detail.delivery_address} root={this.props.root} varTgt="delivery_address"/>
                  <AddressViewer title="Invoice Address" address={this.props.root.state.detail.invoice_address} root={this.props.root} varTgt="invoice_address"/><div className='tidy' />
              </div>)
              }

           var warnBox;
           if(this.state.showWarn){
             var showWarn = this.state.showWarn;
             var warnField;
             var buttons;
             if(!showWarn.buttons){
               showWarn.buttons = [{className:'ok', text:'OK', action: (e)=>{this.setState({showWarn:undefined}); if(typeof showWarn.callback === 'function'){showWarn.callback()}}}]
             }
             if(showWarn.textField){
               var field;
                 if(showWarn.textField.large){
                 field = <textarea value={showWarn.textField.value} onChange={showWarn.textField.handle} />
                  }
                  else {
                   field = <input value={showWarn.textField.value} onChange={showWarn.textField.handle} />
                 }
                warnField = (
                  <div className="warnField">
                      <div className="title">{showWarn.textField.label}:</div>
                      {field}
                  </div>
                )

             }
             warnBox = (
                 <Modal type="confirm" buttons={showWarn.buttons} >
                    <div>
                    {showWarn.message}
                    {warnField}
                    </div>
                 </Modal>
              )
           }
           var actionBox;
           var refclass = "refBox";
           if(this.isAdmin()){
             refclass += ' admin';
              actionBox = (
                    <div className="actionButton"  onClick={this.contextShow.bind(this, 'order')}><i className="fa fa-ellipsis-v" /></div>
                    )
           }
           var sideBar,toggleSide;
           if (this.state.showSide) {
            sideBar = (<div id="SideBar">
               <div className={refclass}>
               {reference}
               {actionBox}
                </div>

               {order_status}
               {order_date}

               <div className="scroll_box">
                   <Scrollbars style={{ width: '100%' }}>
                     {post_services}
                     {address_blocks}
                     {export_options}
                     <ConsignmentViewer fs={true}  onClick={()=>{if(this.isEditable()){console.log('p'); this.editAddress('delivery');}}} consignment={this.props.root.state.detail.consignment} address={this.props.root.state.detail.delivery_address} root={this.props.root} varTgt="consignment"/>
                   </Scrollbars>
               </div>
               {sideButtons}
               {calendar}
             </div>)
              toggleSide = (<div className="toggleSide" onClick={this.toggleSide}>View Make Up</div>);
           }
           else {
              toggleSide = (<div className="toggleSide" onClick={this.toggleSide}>View Details</div>);
           }
      return (
        <div className={className}>
          {toggleSide}
          {warnBox}
          {fixedTop}
          <div>
            {this.props.root.state.detail.status}
          </div>
          {dispatches}
          <div>
            {warn}
          </div>
          <table className="itemList">
            {order_headers}
            {order_items}
          </table>
          <ContextMenu root={this.props.root} options={this.state.context.options}  location={this.state.context.location} parent={this} show={this.state.context.show} />
          <div id="Drawer" className={this.state.drawerState}>
            <div className="drawer_title" onClick={this.toggleDrawer}>Notes & Messages{drawer_info}</div>
            <div className="labels">
                <label for="ta_delivery_instructions">Delivery Instructions</label>
                <label for="ta_notes">Notes</label>
                <label for="ta_gift_message">Gift Message</label>
            </div>
            <div className="options">
                <textarea id="ta_delivery_instructions" placeholder="Delivery Instructions" value={this.props.root.state.detail.delivery_instructions} onChange={this.handler.bind(this, 'delivery_instructions')} />
                <textarea id="ta_notes" placeholder="Notes" value={this.props.root.state.detail.notes} onChange={this.handler.bind(this, 'notes')} />
                <textarea id="ta_gift_message" placeholder="Gift Message" value={this.props.root.state.detail.gift_message}  onChange={this.handler.bind(this, 'gift_message')} />
            </div>
          </div>
          {sideBar}
          {editAddress}
        </div>
      );
    }
    else {
      var multiOption;
      var mergeConfirm;
      var checked;
      var uploadForm;
      if(this.state.uploader){
        uploadForm = (
              <Modal close={this.closeModal} buttons={[{text:'Upload CSV',action:this.uploadCSV}]}>
                <div className="uploadForm">
                    <input type="file" id="uploadTemplate" onChange={e => {
                      console.log(e);

                      var file    = e.target.files[0];
                      var reader  = new FileReader();

                      reader.addEventListener("load", function () {
                        //preview.src = reader.result;
                        console.log(reader.result);
                        var k;
                        var fields;
                        console.log(k = reader.result.split('\n'));
                        console.log(fields = k[0].split(','));

                        var required = ["ID", "OrderId", "SKU", "Quantity", "Channel", "BuyerName", "BuyerAdd1", "BuyerAdd2", "BuyerAdd3", "BuyerCity", "BuyerCounty", "BuyerPostcode", "BuyerCountry", "RecipientName", "RecipientAdd1", "RecipientAdd2", "RecipientAdd3", "RecipientCity", "RecipientCounty", "RecipientPostcode", "RecipientCountry", "OrderVariations", "OrderNotes", "Status", "PurchaseDate", "ShippingMethod"];
                        var _valid  = 1;
                        for(var i = 0; i < required.length; i++){
                            console.log(required[i], fields.includes(required[i]));
                            if (!fields.includes(required[i])){
                              _valid = false;
                            }
                        }
                        console.log(_valid);
                      }, false);
                      if (file) {
                        reader.readAsText(file);
                      }

                    }} />
                </div>
              </Modal>
            )
      }
      var check = this.state.checked;
      if(Array.isArray(check) && check.length === 1){
        
          multiOption = (<div id="mergePrompt">
            Please select more orders to merge.
          </div>)
      }
      else if(Array.isArray(check) && check.length > 1){
          var mergeTo = [];
          checked = check.map(ord => {
              var ord_items = ord.order_items.map(ord_it => {
                  return (<div className="orderItems">{ord_it.product.sku}: {ord_it.product.name} {ord_it.product.qty}</div>)
              })

              mergeTo.push(<option value={ord.id}>{ord.reference}: {ord.delivery_address.forename} {ord.delivery_address.surname}</option>)

              return (<div className="orders">
                        {ord.reference}: {ord.delivery_address.forename} {ord.delivery_address.surname}
                        {ord_items}
              </div>);
          })
          multiOption = (<div id="multiOption">
            <div><button onClick={this.mergeOrders}>Merge Orders</button></div>
            {multiOption}
          </div>)
          if(this.state.mergeConfirm){
            mergeConfirm = (
              <Modal title="Merge Orders" close={this.closeModal} buttons={[{text:'Merge',action:this.merge}]}>
                <div className="mergeConfirm">
                    <select id="mergeTo">
                      {mergeTo}
                    </select>
                    {checked}
                </div>
              </Modal>
            )
          }
      }
      var orders = [];
        console.log(this.props.root.state.current_customer.orders);
      if(!this.props.all_customers && !this.state.orders){
        console.log(this.props.root.state.current_customer.orders);
        orders = this.props.root.state.current_customer.orders;
      }
      else {
        orders = {list: this.state.orders};
      }
      var top_box = [];
      if( this.props.all_customers){
        top_box = (<div className="lookup_container">
                      <input id="lookupBox" value={this.state.dbSearchText} onChange={this.handler.bind(this,'this.dbSearchText')} placeholder="Search All Orders" />
                      <button onClick={this.dbSearch}><i className="material-icons">search</i></button>
                  </div>)
      }
      else if (detail) {
           return (<div className="Order loading">
              <div>Loading</div>
            </div>)
      }
      else {
        top_box = (
                   <div>
            <div className="controls">
              <button onClick={window.open.bind(null,this.props.root.paths.utilityHost + '/utilities/order/template')}>Download Order Template</button>
              <div className="upload_order"><i className="material-icons">add_circle_outline</i><span>Upload Bulk Spreadsheet</span><input id="orderData" type="file" onChange={this.upOrder} /></div>
              {multiOption}
              {mergeConfirm}
              {uploadForm}
              <button onClick={this.createNew}><i className="fa fa-plus" aria-hidden="true" /> Add Order</button>

            </div>
              <div className="lookup_container shared">
                      <input id="lookupBox" value={this.state.dbSearchText} onChange={this.handler.bind(this,'this.dbSearchText')} placeholder="Search All Orders" />
                      <button onClick={this.dbSearch}><i className="material-icons">search</i></button>
                  </div>

              </div>
          )
      }
              console.log(this.state.dbSearchText);
              console.log(this.state);
      return (
        <div className="Orders">
          {top_box}
          <List id="orders" search={this.state.dbSearchText} piper={this.state.dbSearchText} showState={true} setPage={this.setPage} sortAction={this.sortAction} selectable={true} root={this.props.root} checkAction={this.orderCheck} clickAction={Config.tables.orders.click} display={{object:"order", items:orders}} model={Config.tables.orders} />
        </div>
      );
    }
  }
}

export default Order;



// WEBPACK FOOTER //
// ./src/Order.js